import { reportWarn } from '@zhenguo/jssdk/owl'
import Clipboard from 'clipboard'

export default function (app) {
  app.directive('clipboard', {
    bind: function (el, binding /* , vnode */) {
      // console.log(binding)
      if (binding.arg === 'success') {
        el._vClipboard_success = binding.value
      } else if (binding.arg === 'error') {
        el._vClipboard_error = binding.value
      } else {
        const clipboard = new Clipboard(el, {
          text: function () {
            return binding.value
          },
        })
        clipboard.on('success', (e) => {
          const callback = el._vClipboard_success
          if (callback) {
            callback(e)
          } else {
            window.$toasted.show('复制成功')
          }
        })
        clipboard.on('error', (e) => {
          reportWarn({
            name: '复制失败',
            global: true,
            msg: e,
          })
          const callback = el._vClipboard_error
          if (callback) {
            callback(e)
          } else {
            window.$toasted.show('复制失败')
          }
        })
        el._vClipboard = clipboard
      }
    },
    update: function (el, binding) {
      if (binding.arg === 'success') {
        el._vClipboard_success = binding.value
      } else if (binding.arg === 'error') {
        el._vClipboard_error = binding.value
      } else {
        el._vClipboard.text = function () {
          return binding.value
        }
      }
    },
    unbind: function (el, binding) {
      if (binding.arg === 'success') {
        delete el._vClipboard_success
      } else if (binding.arg === 'error') {
        delete el._vClipboard_error
      } else {
        el._vClipboard.destroy()
        delete el._vClipboard
      }
    },
  })
}
